import Col from '@loggi/ui/components/col';
import Text, { TEXT_SIZE_SMALL } from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import React from 'react';
import PropTypes from 'prop-types';

export const ATTEMPT = 'tentativa';
export const ATTEMPTS = 'tentativas';

export default function RemainingAttempts({ remainingAttempts }) {
  return (
    <Col gutter={{ bottom: 'normal' }}>
      <Text size={TEXT_SIZE_SMALL} color={colors.type.DARK}>
        Você tem mais
        <Text size={TEXT_SIZE_SMALL} bold>
          {` ${remainingAttempts} `}
          {remainingAttempts === 1 ? ATTEMPT : ATTEMPTS}.
        </Text>
      </Text>
    </Col>
  );
}

RemainingAttempts.displayName = 'RemainingAttempts';
RemainingAttempts.propTypes = {
  remainingAttempts: PropTypes.number.isRequired
};
